import React from 'react';
import { useTemperature } from '../context/TemperatureContext';
import { 
  FiCheckCircle, 
  FiThermometer, 
  FiWifi, 
  FiClock, 
  FiActivity 
} from 'react-icons/fi';

const RotaStats = () => {
  const { equipmentTotal } = useTemperature();
  const horizontalStats = [
    { 
      icon: FiThermometer, 
      value: equipmentTotal.loading ? '…' : equipmentTotal.error ? '—' : equipmentTotal.value ?? '—',
      title: 'Total Equipment',
      description: equipmentTotal.error || 'Total equipment in the equipment register',
      color: 'text-blue-600 bg-blue-50 border border-blue-100'
    },
    { 
      icon: FiWifi, 
      value: '16',
      title: 'Active Sensors',
      color: 'text-green-600 bg-green-50 border border-green-100'
    },
    { 
      icon: FiClock, 
      value: '1 min ago',
      title: 'Last Update',
      color: 'text-amber-600 bg-amber-50 border border-amber-100'
    },
    { 
      icon: FiActivity, 
      value: '80%',
      title: 'System Health',
      color: 'text-purple-600 bg-purple-50 border border-purple-100'
    },
  ];

  return (
    <section className="mt-6">
      {/* Outer grid split into 1 large status bar area and 1 flexible metrics section area */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">
        
        {/* Left Side: System Shield Guard Banner Card */}
        <div className="lg:col-span-1 bg-white border border-slate-100 rounded-2xl p-5 flex items-center gap-4 shadow-sm">
          <div className="p-3.5 bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center border border-emerald-100 shadow-sm shrink-0">
            <FiCheckCircle className="w-8 h-8" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-800">All System Normal</h3>
            <p className="text-xs text-slate-500 mt-0.5 leading-relaxed">
              All monitored equipment is operating within safe temperature ranges.
            </p>
          </div>
        </div>

        {/* Right Side: 4 Horizontal Mini Metrics Cards Container */}
        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
          {horizontalStats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div 
                key={index} 
                title={stat.description}
                className="bg-white border border-slate-100 rounded-xl p-4 flex items-center gap-3.5 shadow-sm hover:shadow-md transition-shadow duration-200"
              >
                <div className={`p-2.5 rounded-xl ${stat.color} flex items-center justify-center shrink-0`}>
                  <IconComponent className="w-5 h-5" />
                </div>
                <div className="min-w-0">
                  <p className="text-xl font-bold text-slate-800 truncate">
                    {stat.value}
                  </p>
                  <p className="text-xs font-medium text-slate-400 mt-0.5 truncate">
                    {stat.title}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default RotaStats;
